import React, { useEffect } from 'react';
import { gsap } from 'gsap';

const Hero: React.FC = () => {
  useEffect(() => {
    const tl = gsap.timeline();
    
    tl.fromTo('.hero-title', 
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }
    )
    .fromTo('.hero-subtitle', 
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }, 
      '-=0.5'
    )
    .fromTo('.hero-buttons', 
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }, 
      '-=0.3'
    );
  }, []);

  return (
    <section id="home" className="min-h-screen flex items-center justify-center hero-bg relative">
      {/* Stronger Overlay for Better Text Contrast */}
      <div className="hero-overlay-strong"></div>
      
      {/* Content */}
      <div className="section-content">
        <div className="hero-content">
          <h1 className="hero-title heading-xl text-white mb-6 animate-fade-in">
            Maho Fine Foods
          </h1>
          <p className="hero-subtitle text-body-lg text-on-overlay mb-8 animate-slide-up">
            Connecting Premium Suppliers with Exceptional Culinary Establishments
          </p>
          <div className="hero-buttons flex flex-col sm:flex-row gap-4 justify-center animate-slide-up">
            <a href="#services" className="btn-primary text-lg px-10 py-4">
              Explore Our Services
            </a>
            <a href="#contact" className="btn-outline-light text-lg px-10 py-4">
              Join Our Network
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
